import { BasicType, AdvancedType } from '@bay-email/core';

export function isTableBlock(blockType: any) {
	return blockType === BasicType.TABLE || blockType === AdvancedType.TABLE;
}
